module.exports = __webpack_public_path__ + "static/media/demoMMS.d48fec6a.jpg";